module.exports = __webpack_public_path__ + "img/logo3.bf5e8cfb.png";